"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hiphopEgg = {
    name: "hiphop",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["h", "i", "p", "h", "o", "p"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/y2NF3eH.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "374px";
        img.style.height = "375px";
        img.style.transition = "20s all";
        img.style.position = "fixed";
        img.style.right = "-374px";
        img.style.bottom = "0px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.right = "calc(100% + 500px)";
        }, 50);
        // window.setTimeout(function(){
        //   img.style.right = 'calc(100% + 375px)';
        // }, 4500);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 19300);
    },
};
exports.default = hiphopEgg;
